module.exports = __webpack_public_path__ + "static/hoivakotilive_slide_8-9819e619d21406a864e06de612341652.jpg";